module.exports = __webpack_public_path__ + "a348b16b2cb32c8018263c108c7e8660.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/bow-hair-pink-s.png
// module id = 2776
// module chunks = 0